var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pick-plan"},_vm._l((_vm.plans),function(plan,index){return _c('pick-plan-card',{key:index,attrs:{"plan":plan},on:{"plan-picked":function (plan) { return _vm.$emit('plan-picked', plan); }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }